module.exports = __webpack_public_path__ + "5fc655267407dd7dfc54f78503b59388.jpg";